import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Page from 'components/Page'
import {Alerts as AlertsWidget} from 'components/search'
import Path from 'routeLinks'

const Alerts: React.FC = () => {
  return (
    <Page title="Public alerts" showTitle breadcrumbs={[{title: 'alerts'}]}>
      <Stack direction="column" spacing={7} sx={{mt: 3}}>
        <Box sx={{width: '50em'}}>
          <Typography>
            This page contains alerts for the most popular machine learning models in use today.
            Alerts help us identify dangers and notify consumers as quickly as possible. You can{' '}
            <a href={Path.alerts.create()}>create your own alerts</a> for your use case too.
          </Typography>
          <br />
          <Typography>
            Some information about the failure cases of the models on this page is redacted. This is
            for your safety. Information such as jailbreak strings can be used to turn enable a
            model to write instructions for more effective terrorist attacks or other nefarious
            activities.{' '}
            {/*If you are aware of a vulnerability or issue not listed below, you can use
            our reporting tool and collect a bounty once your vulnerability is verified. We notify
            publishers privately of notifications and make extreme efforts to never reveal
            information hazards to the public. */}
          </Typography>
        </Box>

        <AlertsWidget searchbar />

        <Box sx={{m: 3}}></Box>
      </Stack>
    </Page>
  )
}

export default Alerts
